module.exports = __webpack_public_path__ + "static/media/diligencia.bd21c6ed.png";